'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _uniqueId = require('lodash/uniqueId');var _uniqueId2 = _interopRequireDefault(_uniqueId);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);

var _reactRouter = require('react-router');
var _HeaderPhones = require('../HeaderPhones/HeaderPhones');var _HeaderPhones2 = _interopRequireDefault(_HeaderPhones);

var _appendLocale = require('../../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _formatAddress = require('../../../utils/formatAddress');var _formatAddress2 = _interopRequireDefault(_formatAddress);

var _constants = require('../../../constants');

var _AboutCompany = require('./AboutCompany.scss');var styles = _interopRequireWildcard(_AboutCompany);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} // Constants
// Helper
// Components
var PURPLE_STAMP_ARTICLE_LINK = '/articles/B11Zlhoj8'; // styles
// Modules
var AboutCompany = function AboutCompany(props) {var _cx3;var communityLogo = { backgroundImage: 'url(\'' + _constants.brokerCommunityStamp + '\')' };
  var associationLogo = { backgroundImage: 'url(\'' + _constants.brokerAssociationStamp + '\')' };
  var purpleStampLogo = { backgroundImage: 'url(\'' + _constants.purpleStamp + '\')' };

  var renderCompanyBranch = function renderCompanyBranch(name, address, isDefaultLang) {var _cx;return (
      _react2.default.createElement('p', { className: (0, _classnames2.default)(styles.addressBlock, (_cx = {}, _cx[styles.defaultLang] = isDefaultLang, _cx)), key: (0, _uniqueId2.default)('branch') },
        _react2.default.createElement('span', { className: 'icon icon-office' }),
        name || props.translate('filial'), ':\xA0\xA0', address));};



  var renderAddress = function renderAddress(address) {return (
      _react2.default.createElement('p', { className: styles.addressBlock },
        _react2.default.createElement('span', { className: 'icon icon-office' }),
        props.translate('address'), ':\xA0\xA0', address));};



  var renderCompanyBranches = function renderCompanyBranches() {var
    branches = props.branches,locale = props.locale;

    if (branches && branches.length === 1) {
      var address = (0, _get2.default)(branches, '[0].address') || {};
      var formattedAddress = typeof address === 'string' ?
      address :
      (0, _formatAddress2.default)(address[locale] || address.en);

      return renderAddress(formattedAddress);
    }

    return branches.map(function (_ref) {var name = _ref.name,address = _ref.address;
      var localizedName = name && (name[locale] || name[_constants.language.default]);
      var isNameAtDefaultLang = name && !name[locale];
      var formattedAddress = typeof address === 'string' ?
      address :
      (0, _formatAddress2.default)(address[locale] || address.en);

      return renderCompanyBranch(localizedName, formattedAddress, isNameAtDefaultLang);
    });
  };

  var renderCompanyLogo = function renderCompanyLogo() {var _cx2;return (
      _react2.default.createElement('div', { className: styles.companyLogo },
        props.company.is_community_member &&
        _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(props.locale, '/professionals/broker') },
          _react2.default.createElement('span', { className: styles.communityStamp, style: communityLogo })),


        props.company.is_association_member &&
        _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(props.locale, '/professionals') },
          _react2.default.createElement('span', { className: styles.associationStamp, style: associationLogo })),


        props.company.has_purple_stamp &&
        _react2.default.createElement(_reactRouter.Link, { to: PURPLE_STAMP_ARTICLE_LINK },
          _react2.default.createElement('span', {
            className: (0, _classnames2.default)(styles.purpleStamp, (_cx2 = {}, _cx2[styles.withBroker] = props.company.is_community_member, _cx2)),
            style: purpleStampLogo })),



        _react2.default.createElement('div', { className: styles.logoImg },
          _react2.default.createElement('img', { src: props.companyLogo, alt: '' }))));};




  var renderCompanyName = function renderCompanyName() {return (
      _react2.default.createElement('div', { className: styles.infoBlock_title },
        _react2.default.createElement('h1', null, props.companyName)));};



  var renderPhones = function renderPhones() {return (
      _react2.default.createElement(_HeaderPhones2.default, {
        translate: props.translate,
        phoneNumber: props.phoneNumber,
        locale: props.locale,
        isMobile: props.isMobile }));};



  return (
    _react2.default.createElement('div', { className: styles.wrapper },
      renderCompanyLogo(),
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.infoBlock, (_cx3 = {}, _cx3[styles.withCommunity] = props.company.is_community_member, _cx3)) },
        props.companyName &&
        renderCompanyName(),

        props.phoneNumber && renderPhones(),

        renderCompanyBranches())));



};

AboutCompany.propTypes = {
  isMobile: _propTypes2.default.bool,
  company: _propTypes2.default.object,
  onShowPhones: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  branches: _propTypes2.default.array,
  companyLogo: _propTypes2.default.string,
  companyName: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  is_association_member: _propTypes2.default.bool,
  phoneNumber: _propTypes2.default.string,
  address: _propTypes2.default.string,
  isNameAtDefaultLang: _propTypes2.default.bool,
  isShowPhone: _propTypes2.default.bool };exports.default =


AboutCompany;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/AboutCompany/AboutCompany.js
// module id = 2621
// module chunks = 0